module.exports = __webpack_public_path__ + "img/sound_off_hover.09c4d003.svg";